import React, { useEffect } from 'react';
import { isToggleOpen, WEEKDAYS, WEEKEND, ALL_DAYS } from './utils';
import DayInputs from './DayInputs';
import { LabeledToggle } from '../../../../../common/MUI';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  label: {
    flex: 'none'
  }
});

const DayOfWeekDriverCountInput = ({
  classes,
  driverPreferenceInfo,
  errorInfo,
  handleChange,
  toggleState,
  handleToggleState
}) => {
  useEffect(() => {
    initializeToggleState();
  }, []);

  const initializeToggleState = () => {
    // Check if there any weekday or weekend values and accordingly set the toggle state
    const hasDayOfWeekValues = isToggleOpen(ALL_DAYS, driverPreferenceInfo);
    const hasWeekendValues = isToggleOpen(WEEKEND, driverPreferenceInfo);

    const newToggleState = {
      dayOfWeek: hasDayOfWeekValues,
      weekend: hasWeekendValues
    };

    handleToggleState(newToggleState);
  };

  const updateDriverCounts = (days, checked) => {
    // If the toggle is checked, set the default driver count, otherwise set to null
    const defaultValue = driverPreferenceInfo?.defaultDriverCount;
    if (checked && !defaultValue) return;
    days.forEach(({ field }) => {
      const newValue = checked ? defaultValue : null;
      handleChange(field)(newValue);
    });
  };

  const handleDayOfWeekToggle = (checked) => {
    updateDriverCounts(WEEKDAYS, checked);
    // Whenever changing the toggle state of day of week, set the weekend toggle to false
    updateDriverCounts(WEEKEND, false);
    const newToggleState = {
      dayOfWeek: checked,
      weekend: false
    };
    handleToggleState(newToggleState);
  };

  const handleWeekendToggle = (checked) => {
    updateDriverCounts(WEEKEND, checked);
    const newToggleState = { weekend: checked };
    handleToggleState(newToggleState);
  };

  const onChange = (field) => (value) => {
    // If the value is empty, set to null, otherwise set to the value
    const changedValue = value === '' ? null : value;
    handleChange(field)(changedValue);
  };

  return (
    <div>
      <LabeledToggle
        checked={toggleState.dayOfWeek}
        onChange={handleDayOfWeekToggle}
        label="DAY OF WEEK DRIVER COUNT"
        classes={{ label: classes.label }}
      />

      {toggleState.dayOfWeek && (
        <>
          <DayInputs
            days={WEEKDAYS}
            handleChange={onChange}
            driverPreferenceInfo={driverPreferenceInfo}
            errorInfo={errorInfo}
          />

          <LabeledToggle
            checked={toggleState.weekend}
            onChange={handleWeekendToggle}
            label="INCLUDE WEEKENDS"
            classes={{ label: classes.label }}
          />

          {toggleState.weekend && (
            <DayInputs
              days={WEEKEND}
              handleChange={onChange}
              driverPreferenceInfo={driverPreferenceInfo}
              errorInfo={errorInfo}
            />
          )}
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(DayOfWeekDriverCountInput);
